const FREE_PLAN = [{
  title: 'Unlimited Screenplays',
  description: 'Create as many screenplays as you want without limitation',
  enabled: true
}, {
  title: 'Automatic Cloud sync and Backup',
  description: '',
  enabled: true
}, {
  title: 'History',
  description: 'Access previous versions of your scripts.',
  limited: 'Last 3 days',
  enabled: true
}, {
  title: 'PDF and Final Draft export',
  description: '',
  limited: 'Watermarked',
  enabled: true
}, {
  title: 'Brainstorming',
  description: 'Brainstorm with FinalBit: Ask Questions on Screenplay Writing.',
  limited: '100 request per month',
  enabled: true
}, {
  title: 'Co Pilot/AI requests',
  description: 'Ask AI change accent, continue dialogue, change ton of text',
  limited: '30 request per month',
  enabled: true
}, {
  title: 'AI Image Generations',
  description: 'Draw Scenes and Characters',
  limited: '5 request per month',
  enabled: true
}, {
  title: 'Screenplay Title Generations',
  description: '',
  enabled: false
}, {
  title: 'Script Doctor',
  description: 'Improve, refine, and fix your script—from formatting to pacing and beyond.',
  enabled: false
}, {
  title: 'Script Breakdown',
  description: 'Screenplay Breakdown',
  enabled: false
}, {
  title: 'Create Scene',
  description: 'Import your scene\'s beat sheet and let FinalBit generate the initial draft of your scene.',
  enabled: false
}, {
  title: 'Script Sharing',
  description: '',
  enabled: false
}, {
  title: 'ColLab:  Virtual Writers\' Room',
  description: 'Invite others to join FinalBit and co-write  and edit scripts seamlessly.',
  enabled: false
}, {
  title: 'Plot Hole Detection Report',
  description: 'Enhance your storytelling by improving narrative consistency with our analysis tool.',
  enabled: false
}]

const COMPACT_FREE_PLAN = [{
  title: 'Unlimited Screenplays',
  description: 'Create as many screenplays as you want without limitation',
  enabled: true
}, {
  title: 'Automatic Cloud sync and Backup',
  description: '',
  enabled: true
}, {
  title: 'History last 3 days',
  description: 'Access previous versions of your scripts.',
  limited: 'Last 3 days',
  enabled: true
}, {
  title: 'PDF and Final Draft export Watermarked',
  description: '',
  limited: 'Watermarked',
  enabled: true
}, {
  title: 'Brainstorming',
  description: 'Brainstorm with FinalBit: Ask Questions on Screenplay Writing.',
  limited: '1000 request per month',
  enabled: true
}, {
  title: 'Co Pilot/AI 30 requests per month',
  description: 'Ask AI change accent, continue dialogue, change ton of text',
  limited: '200 request per month',
  enabled: true
}, {
  title: 'AI Image Generations 5 requests per month',
  description: 'Ask AI change accent, continue dialogue, change ton of text',
  limited: '200 request per month',
  enabled: true
}, {
  title: 'Storyboard 5 frames per scene',
  description: 'Ask AI change accent, continue dialogue, change ton of text',
  limited: '200 request per month',
  enabled: true
}, {
  title: 'Scheduling for 1 script',
  description: 'Ask AI change accent, continue dialogue, change ton of text',
  limited: '200 request per month',
  enabled: true
}, {
  title: 'Script Breakdown for 1 script',
  description: 'Ask AI change accent, continue dialogue, change ton of text',
  limited: '200 request per month',
  enabled: true
}]

const COMPACT_BASIC_PLAN = [{
  title: 'Screenplay Title Generations',
  description: '',
  enabled: true
}, {
  title: 'Script Doctor',
  description: 'Improve, refine, and fix your script—from formatting to pacing and beyond.',
  enabled: true
}, {
  title: 'Unlimited Script Breakdown',
  description: '',
  enabled: true
}, {
  title: 'Create Scene',
  description: '',
  enabled: true
}, {
  title: 'PDF and Final Draft import',
  description: '',
  enabled: true
}, {
  title: 'Script Sharing',
  description: '',
  enabled: true
}, {
  title: 'Storyboard with Basic AI image generation',
  description: '',
  enabled: true
}, {
  title: 'Script Coverage Report for 10 scripts / No AI',
  enabled: true
}/*, {
  title: 'Scheduling for 10 scripts',
  description: 'Ask AI change accent, continue dialogue, change ton of text',
  limited: '200 request per month',
  enabled: true
} */]

const BASIC_PLAN = [{
  title: 'Unlimited Screenplays',
  description: 'Create as many screenplays as you want without limitation',
  enabled: true
}, {
  title: 'Automatic Cloud sync and Backup',
  description: '',
  enabled: true
}, {
  title: 'History',
  description: 'Access previous versions of your scripts.',
  limited: 'Last 30 days',
  enabled: true
}, {
  title: 'PDF and Final Draft import/export',
  description: '',
  enabled: true
}, {
  title: 'Brainstorming',
  description: 'Brainstorm with FinalBit: Ask Questions on Screenplay Writing.',
  limited: '1000 request per month',
  enabled: true
}, {
  title: 'Co Pilot/AI requests',
  description: 'Ask AI change accent, continue dialogue, change ton of text',
  limited: '200 request per month',
  enabled: true
}, {
  title: 'AI Image Generations',
  description: 'Draw Scenes and Characters',
  limited: '20 request per month',
  enabled: true
}, {
  title: 'Screenplay Title Generations',
  description: '',
  enabled: true
}, {
  title: 'Script Doctor',
  description: 'Improve, refine, and fix your script—from formatting to pacing and beyond.',
  enabled: true
}, {
  title: 'Unlimited Script Breakdown',
  description: 'Screenplay Breakdown and summary',
  enabled: true
}, {
  title: 'Create Scene',
  description: 'Import your scene\'s beat sheet and let FinalBit generate the initial draft of your scene.',
  limited: '50 scenes per month',
  enabled: true
}, {
  title: 'Script Sharing',
  description: '',
  enabled: true
}, {
  title: 'ColLab:  Virtual Writers\' Room',
  description: 'Invite others to join FinalBit and co-write  and edit scripts seamlessly.',
  enabled: false
}, {
  title: 'Plot Hole Detection Report',
  description: 'Enhance your storytelling by improving narrative consistency with our analysis tool.',
  enabled: false
}]

const COMPACT_BASIC_PLUS_PLAN = [{
  title: 'Unlimited - Co Pilot/AI requests',
  description: 'Ask AI change accent, continue dialogue, change ton of text',
  limited: '200 request per month',
  enabled: true
}, {
  title: 'Unlimited - AI Image Generations',
  description: 'Ask AI change accent, continue dialogue, change ton of text',
  limited: '200 request per month',
  enabled: true
}, {
  title: 'Unlimited - Brainstorming',
  description: 'Brainstorm with FinalBit: Ask Questions on Screenplay Writing.',
  limited: '1000 request per month',
  enabled: true
}, {
  title: 'Unlimited - Scheduling',
  description: 'Ask AI change accent, continue dialogue, change ton of text',
  limited: '200 request per month',
  enabled: true
}]

const BASIC_PLUS_PLAN = [{
  title: 'Unlimited Screenplays',
  description: 'Create as many screenplays as you want without limitation',
  enabled: true
}, {
  title: 'Automatic Cloud sync and Backup',
  description: '',
  enabled: true
}, {
  title: 'History',
  description: 'Access previous versions of your scripts.',
  limited: 'Last 90 days',
  enabled: true
}, {
  title: 'PDF and Final Draft import/export',
  description: '',
  enabled: true
}, {
  title: 'Brainstorming',
  description: 'Brainstorm with FinalBit: Ask Questions on Screenplay Writing.',
  enabled: true
}, {
  title: 'Co Pilot/AI requests',
  description: '<strong>Co-Pilot will analyze twice as much content as Free and Basic Plans.</strong> Ask AI to change accent, continue dialogue, and alter the tone of the text. ',
  enabled: true
}, {
  title: 'AI Image Generations',
  description: 'Draw Scenes and Characters',
  enabled: true
}, {
  title: 'Screenplay Title Generations',
  description: '',
  enabled: true
}, {
  title: 'Script Doctor',
  description: 'Improve, refine, and fix your script—from formatting to pacing and beyond.',
  enabled: true
}, {
  title: 'Unlimited Script Breakdown',
  description: 'Screenplay Breakdown and summary',
  enabled: true
}, {
  title: 'Create Scene',
  description: 'Import your scene\'s beat sheet and let FinalBit generate the initial draft of your scene.',
  enabled: true
}, {
  title: 'Script Sharing',
  description: '',
  enabled: true
}, {
  title: 'ColLab:  Virtual Writers\' Room',
  description: 'Invite others to join FinalBit and co-write  and edit scripts seamlessly.',
  enabled: false
}, {
  title: 'Plot Hole Detection Report',
  description: 'Enhance your storytelling by improving narrative consistency with our analysis tool.',
  enabled: false
}]

const COMPACT_PRO_PLAN = [{
  title: 'ColLab: Virtual Writers\' Room',
  description: '',
  enabled: true
}, {
  title: 'Plot Hole Detection Report',
  description: '',
  enabled: true
}, {
  title: 'Automatic Script Breakdown: Break down the whole script within a few minutes.',
  description: '',
  enabled: true
}, {
  title: 'PRO AI unlimited requests',
  description: '',
  enabled: true
}, {
  title: 'Unlimited - Storyboard with PRO AI image generation',
  description: '',
  enabled: true
}, {
  title: 'Unlimited - Scheduling + Scene Shooting Duration Estimations',
  description: 'Ask AI change accent, continue dialogue, change ton of text',
  limited: '200 request per month',
  enabled: true
}, {
  title: 'Script Coverage Report with AI',
  enabled: true
}]

const PRO_PLAN = [{
  title: 'Unlimited Screenplays',
  description: 'Create as many screenplays as you want without limitation',
  enabled: true
}, {
  title: 'Automatic Cloud sync and Backup',
  description: '',
  enabled: true
}, {
  title: 'History',
  description: 'Access previous versions of your scripts.',
  enabled: true
}, {
  title: 'PDF and Final Draft import/export',
  description: '',
  enabled: true
}, {
  title: 'Brainstorming',
  description: 'Brainstorm with FinalBit: Ask Questions on Screenplay Writing.',
  enabled: true
}, {
  title: 'Co Pilot/AI requests',
  description: 'Co-Pilot will analyze twice as much content as Free and Basic Plans. Ask AI to change accent, continue dialogue, and alter the tone of the text. ',
  enabled: true
}, {
  title: 'AI Image Generations',
  description: 'Draw Scenes and Characters',
  enabled: true
}, {
  title: 'Screenplay Title Generations',
  description: '',
  enabled: true
}, {
  title: 'Script Doctor',
  description: 'Improve, refine, and fix your script—from formatting to pacing and beyond.',
  enabled: true
}, {
  title: 'Break Smart',
  description: 'Screenplay Breakdown',
  enabled: true
}, {
  title: 'Create Scene',
  description: 'Import your scene\'s beat sheet and let Nolan generate the initial draft of your scene.',
  enabled: true
}, {
  title: 'Script Sharing',
  description: '',
  enabled: true
}, {
  title: 'ColLab:  Virtual Writers\' Room',
  description: 'Invite others to join FinalBit and co-write  and edit scripts seamlessly.',
  enabled: true
}, {
  title: 'Plot Hole Detection Report',
  description: 'Enhance your storytelling by improving narrative consistency with our analysis tool.',
  enabled: true
}, {
  title: 'Script Coverage Report',
  description: 'Enhance your storytelling by improving narrative consistency with our analysis tool.',
  enabled: true
}]

const PLANS = [{
  title: 'Free Forever',
  id: 'free',
  descriptions: 'Get started with our free plan and enjoy essential features without any cost. Perfect for individuals',
  prices: {
    monthly: {
      price: 0,
      discount: 0
    },
    '3month': {
      price: 0,
      discount: 0
    },
    yearly: {
      price: 0,
      discount: 0
    }
  },
  items: FREE_PLAN,
  compactItems: COMPACT_FREE_PLAN
}, /* {
  title: 'Basic',
  id: 'basic',
  descriptions: 'Upgrade to our Basic plan for a budget-friendly option that unlocks additional functionalities.',
  prices: {
    monthly: {
      price: '6.99',
      discount: 0
    },
    '3month': {
      price: '20.99',
      discount: 0
    },
    yearly: {
      price: '83.99',
      discount: 0
    }
  },
  items: BASIC_PLAN,
  compactItems: COMPACT_BASIC_PLAN,
  level: 1
}, */ {
  title: 'Basic',
  id: 'basicPlus',
  descriptions: 'Upgrade to our Basic plan that unlocks additional functionalities with UNLIMITED AI requests.',
  prices: {
    monthly: {
      price: '29.99',
      discount: 0
    },
    '3month': {
      price: '80.99',
      oldPrice: '89.99',
      discount: 10
    },
    yearly: {
      price: '251.99',
      oldPrice: '359.99',
      discount: 30
    }
  },
  items: BASIC_PLUS_PLAN,
  compactItems: [...COMPACT_BASIC_PLAN, ...COMPACT_BASIC_PLUS_PLAN],
  level: 2
}, {
  title: 'Pro',
  id: 'pro',
  descriptions: 'Experience the ultimate power and versatility of our Pro plan. Gain access to advanced features, priority support.',
  prices: {
    monthly: {
      price: '49.99',
      discount: 0
    },
    '3month': {
      price: '134.99',
      oldPrice: '149.99',
      discount: 10
    },
    yearly: {
      price: '419.99',
      oldPrice: '599.99',
      discount: 0
    }
  },
  items: PRO_PLAN,
  compactItems: COMPACT_PRO_PLAN,
  level: 3
}
//   {
//   title: 'Enterprise',
//   id: 'enterprise',
//   descriptions: 'All features unlimited in Pro plan and custom solutions'
// }
]

const TABLE_LIST = [{
  title: 'Unlimited Screenplays',
  description: 'Create as many screenplays as you want without limitation',
  free: { enabled: true },
  basic: { enabled: true },
  basicPlus: { enabled: true },
  pro: { enabled: true }
}, {
  title: 'Automatic Cloud sync and Backup',
  description: '',
  free: { enabled: true },
  basic: { enabled: true },
  basicPlus: { enabled: true },
  pro: { enabled: true }
}, {
  title: 'History',
  description: 'Access previous versions of your scripts.',
  free: { enabled: true, limited: 'Last 3 days' },
  basic: { enabled: true, limited: 'Last 30 days' },
  basicPlus: { enabled: true, limited: 'Last 90 days' },
  pro: { enabled: true }
}, {
  title: 'Brainstorming',
  description: 'Brainstorm with FinalBit: Ask Questions on Screenplay Writing.',
  free: { enabled: true, limited: 'Basic AI 100 request per month' },
  basic: { enabled: true, limited: 'Basic AI 1000 request per month' },
  basicPlus: { enabled: true, limited: 'Basic AI unlimited requests' },
  pro: { enabled: true, limited: 'PRO AI unlimited requests' }
}, {
  title: 'Co Pilot/AI requests',
  description: 'Ask AI change accent, continue dialogue, change ton of text',
  free: { enabled: true, limited: 'Basic AI 30 request per month' },
  basic: { enabled: true, limited: 'BASIC AI 200 request per month' },
  basicPlus: { enabled: true, limited: 'Unlimited  BASIC AI requests. Co-Pilot will analyze twice as much content as Free and Basic Plans.' },
  pro: { enabled: true, limited: 'Unlimited PRO AI requests. Co-Pilot will analyze twice as much content as Free and Basic Plans.' }
}, {
  title: 'AI Image Generations',
  description: 'Draw Scenes and Characters',
  free: { enabled: true, limited: '5 request per month' },
  basic: { enabled: true, limited: '20 request per month' },
  basicPlus: { enabled: true, limited: 'Unlimited' },
  pro: { enabled: true, limited: 'Unlimited' }
}, {
  title: 'PDF and Final Draft export',
  description: '',
  free: { enabled: true, limited: 'Watermarked' },
  basic: { enabled: true },
  basicPlus: { enabled: true },
  pro: { enabled: true }
}, {
  title: 'Script Sharing',
  description: '',
  free: { enabled: true },
  basic: { enabled: true },
  basicPlus: { enabled: true },
  pro: { enabled: true }
}, {
  title: 'Storyboard',
  description: 'Automated storyboard.',
  free: { enabled: true, limited: 'Five frames per scene and no AI image generation.' },
  basic: { enabled: true, limited: 'Basic AI image generation' },
  basicPlus: { enabled: true, limited: 'Basic AI image generation' },
  pro: { enabled: true, limited: 'PRO AI image generation' }
}, {
  title: 'Scheduling',
  description: 'Automatically sorts your stripboard in the most efficient way for shooting.',
  free: { enabled: true, limited: '1 script' },
  basic: { enabled: true, limited: '10 scripts' },
  basicPlus: { enabled: true, limited: 'Unlimited scripts' },
  pro: { enabled: true, limited: 'Unlimited scripts + Scene Shooting Duration Estimations' }
}, {
  title: 'Scheduling',
  description: 'Automatically sorts your stripboard in the most efficient way for shooting.',
  free: { enabled: true, limited: '1 script' },
  basic: { enabled: true, limited: '10 scripts' },
  basicPlus: { enabled: true, limited: 'Unlimited scripts' },
  pro: { enabled: true, limited: 'Unlimited scripts + Scene Shooting Duration Estimations' }
}, {
  title: 'Shot List',
  description: 'Effortlessly organize your shooting plan with shot lists linked to scheduling and storyboarding.',
  free: { enabled: true },
  basic: { enabled: true },
  basicPlus: { enabled: true },
  pro: { enabled: true }
}, {
  title: 'PDF and Final Draft import',
  description: '',
  free: { enabled: false },
  basic: { enabled: true },
  basicPlus: { enabled: true },
  pro: { enabled: true }
}, {
  title: 'Screenplay Title Generations',
  description: '',
  free: { enabled: false },
  basic: { enabled: true },
  basicPlus: { enabled: true },
  pro: { enabled: true }
}, {
  title: 'Script Doctor',
  description: 'Improve, refine, and fix your script—from formatting to pacing and beyond.',
  free: { enabled: false },
  basic: { enabled: true },
  basicPlus: { enabled: true },
  pro: { enabled: true }
}, {
  title: 'Script Breakdown',
  description: 'Break down your script with one click',
  free: { enabled: true, limited: '1 script' },
  basic: { enabled: true, limited: 'Semi-Automatic Script Breakdown' },
  basicPlus: { enabled: true, limited: 'Unlimited scripts and Semi-Automatic Script Breakdown' },
  pro: { enabled: true, limited: 'Unlimited scripts + Automatic Script Breakdown: Break down the whole script within a few minutes.' }
}, {
  title: 'Create Scene',
  description: 'Import your scene\'s beat sheet and let FinalBit generate the initial draft of your scene.',
  free: { enabled: false },
  basic: { enabled: true, limited: 'Basic AI 50 scenes per month' },
  basicPlus: { enabled: true, limited: 'Basic AI Unlimited scenes' },
  pro: { enabled: true, limited: 'PRO AI Unlimited scenes' }
}, {
  title: 'ColLab:  Virtual Writers\' Room',
  description: 'Invite others to join FinalBit and co-write  and edit scripts seamlessly.',
  free: { enabled: false },
  basic: { enabled: false },
  basicPlus: { enabled: false },
  pro: { enabled: true }
}, {
  title: 'Plot Hole Detection Report',
  description: 'Enhance your storytelling by improving narrative consistency with our analysis tool.',
  free: { enabled: false },
  basic: { enabled: false },
  basicPlus: { enabled: false },
  pro: { enabled: true }
}, {
  title: 'Script Coverage Report',
  description: '',
  free: { enabled: false },
  basic: { enabled: false },
  basicPlus: { enabled: false },
  pro: { enabled: true }
}]

const PROFILE_SUBSCRIPTION_PLANS = [{
  title: 'Basic',
  id: 'free',
  descriptions: 'Get started with our free plan and enjoy essential features without any cost. Perfect for individuals',
  prices: {
    monthly: {
      price: 0,
      discount: 0
    },
    '3month': {
      price: 0,
      discount: 0
    },
    yearly: {
      price: 0,
      discount: 0
    }
  },
  items: FREE_PLAN,
  compactItems: COMPACT_FREE_PLAN
}, {
  title: 'Basic legacy',
  id: 'basic',
  descriptions: 'Upgrade to our Basic plan for a budget-friendly option that unlocks additional functionalities.',
  prices: {
    monthly: {
      price: '6.99',
      discount: 0
    },
    '3month': {
      price: '20.99',
      discount: 0
    },
    yearly: {
      price: '83.99',
      discount: 0
    }
  },
  items: BASIC_PLAN,
  compactItems: COMPACT_BASIC_PLAN,
  level: 1
}, {
  title: 'Creator',
  id: 'basicPlus',
  descriptions: 'Upgrade to our Basic plan that unlocks additional functionalities with UNLIMITED AI requests.',
  prices: {
    monthly: {
      price: '29.99',
      discount: 0
    },
    '3month': {
      price: '89.99',
      discount: 0
    },
    yearly: {
      price: '359.99',
      discount: 0
    }
  },
  items: BASIC_PLUS_PLAN,
  compactItems: [...COMPACT_BASIC_PLAN, ...COMPACT_BASIC_PLUS_PLAN],
  level: 2
}, {
  title: 'Pro',
  id: 'pro',
  descriptions: 'Experience the ultimate power and versatility of our Pro plan. Gain access to advanced features, priority support.',
  prices: {
    monthly: {
      price: '49.99',
      discount: 0
    },
    '3month': {
      price: '149.99',
      discount: 0
    },
    yearly: {
      price: '599.99',
      discount: 0
    }
  },
  items: PRO_PLAN,
  compactItems: COMPACT_PRO_PLAN,
  level: 3
}
//   {
//   title: 'Enterprise',
//   id: 'enterprise',
//   descriptions: 'All features unlimited in Pro plan and custom solutions'
// }
]

export {
  PLANS,
  PRO_PLAN,
  BASIC_PLAN,
  FREE_PLAN,
  COMPACT_FREE_PLAN,
  COMPACT_BASIC_PLAN,
  COMPACT_PRO_PLAN,
  COMPACT_BASIC_PLUS_PLAN,
  TABLE_LIST,
  PROFILE_SUBSCRIPTION_PLANS
}
